import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { deleteActivityType, getActivityTypebycropsorlivestockpage } from "./ServiceActivityType";

import ConfirmationModal from "../../components/home/ConfirmationModal";
import "moment/locale/fr";
import moment from "moment";
import { useTranslation } from "react-i18next";
export default function ListActivityType() {

  const { t } = useTranslation();

    const getActivityTypeLabel = (type) => {
    switch (type) {
        case "C":
           return t("monProfile.activityTypes.agriculture");
        case "L":
            return t("monProfile.activityTypes.livestock");
        default:
            return type || "";
    }
};

  /**************************Pagination*********************************/
  const [totalpage, setTotalPages] = useState();
  const [currentPage, setCurrentPage] = useState(0);
  const totalPages = totalpage;
  const range = 1;
  const startRange = Math.max(currentPage - range, 0);
  const endRange = Math.min(currentPage + range, totalPages - 1);
  const firstPage = () => {
    setCurrentPage(0);
  };
  const lastPage = () => {
    setCurrentPage(totalPages - 1);
  };

  const prePage = () => {
    if (currentPage !== 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = () => {
    if (currentPage !== totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  //Nombre D'enregistrement par table
  const [nombrEnreg, setNombreEnrg] = useState(5);

  /********* cropsOrLivestock**************************************************/
  const [val, setVal] = useState("");


  /*********Searche Data**************************************************/
  const [search, setSearch] = useState("");

  /*******************Ordonné la table par ASC ,DESC**********************/
  const [order, setOrder] = useState("ASC");
  const SortTableAsc = () => {
    if (order === "DESC") {
      setOrder("ASC");
    }
  };

  const SortTableDesc = () => {
    if (order === "ASC") {
      setOrder("DESC");
    }
  };



  /*************Trier par champs des tables*****************************/
  const [selectedValues, setSelectedValues] = useState([]);
  //convertir le tableau en caine de caractere
  const [seletedValuesChaine, setseletedValuesChaine] = useState("");

  const handleCheckBoxChange = (e) => {
    const value = e.target.value;
    const checked = e.target.checked;
    if (checked) {
      // La valeur n'est pas sélectionnée, l'ajouter au tableau
      setSelectedValues([...selectedValues, value]);
    } else {
      // La valeur existe dans le tableau la supprimer
      setSelectedValues(selectedValues.filter((val) => val !== value));
    }
  };

  /*************Charger les données************************************/
  const [activitytypeData, SetactivitytypeData] = useState([]);

  const loadactivitytype = async () => {

    //console.log("val =", val);

    const result = await getActivityTypebycropsorlivestockpage(
      val,
      search,
      currentPage,
      nombrEnreg,
      seletedValuesChaine,
      order
    );

    //console.log(result.data);

    result.data.content.forEach(e => {
      console.log(e.id, e.cropsOrLivestock, e.activityType
      );
    });

    SetactivitytypeData(result.data.content);
    setTotalPages(result.data.totalPages);
  };

  //Gerer les erreurs renvoyer du serveurs
  //const [errorMessage, setErrorMessage] = useState([]);

  /*********************Delete Data*************************************/
  const [activitytypeId, setactivitytypeId] = useState();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  const selectId = (id) => {
    setactivitytypeId(id);
    setShowConfirmationModal(true); //afficher le modal

  };

  const handleCloseModal = () => {
    setShowConfirmationModal(false); //fermer le modal
  };

  const deleteactivitytype = async () => {
    try {
      await deleteActivityType(activitytypeId);
      loadactivitytype();

      setShowConfirmationModal(false); //fermer le modal
      toast.success(t("commune.deleteSuccess"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000, // Temps d'affichage du toast (en millisecondes)
        //hideProgressBar: true, // Masquer la barre de progression
        closeOnClick: true, // {t("button.close")} le toast lorsqu'il est cliqué
        pauseOnHover: true, // Mettre en pause la durée de vie du toast lorsqu'il est survolé
        draggable: true, // Permettre de faire glisser le toast
        //progress: undefined, // Composant personnalisé pour la barre de progression
        // ...autres options
      });
    } catch (error) {
      if (error.response && error.response.data && error.response.data.errors) {
        // Récuperer les erreurs de validation ou le message d'erreur renvoyé par le serveur
        const errorArray = error.response.data.errors;

        //afficher les erreurs dans le toast
        const formattedErrors = errorArray.map((error, index) => {
          return (
            <li className="list-group-item" key={index}>
              {error}
            </li>
          );
        });

        toast.error(
          <div style={{ width: "15rem" }}>
            <div className="card-header text-danger">
              <h5 className="card-title">Erreurs de suppression !</h5>
            </div>
            <div className="card-body">
              <p className="card-text"></p>
              <ul className="list-group list-group-flush">{formattedErrors}</ul>
            </div>
          </div>,
          {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000, // Temps d'affichage du toast (en millisecondes)
            //hideProgressBar: true, // Masquer la barre de progression
            closeOnClick: true, // {t("button.close")} le toast lorsqu'il est cliqué
            pauseOnHover: true, // Mettre en pause la durée de vie du toast lorsqu'il est survolé
            draggable: true, // Permettre de faire glisser le toast
            //progress: undefined, // Composant personnalisé pour la barre de progression
            // ...autres options
          }
        );
        setShowConfirmationModal(false); //fermer le modal
      } else {
        console.log(
          "Une erreur s'est produite lors de la suppression des données."
        );
      }
    }
  };

  /*********************************************************************/

  useEffect(() => {
    if (currentPage >= totalPages) {
      setCurrentPage(0);
    }

    setseletedValuesChaine(selectedValues.join(","));
    loadactivitytype();
  }, [
    val,
    search,
    currentPage,
    nombrEnreg,
    seletedValuesChaine,
    order,
    selectedValues,
    totalPages,
  ]);

  return (
    <div className="container-fluid px-4" style={{ marginTop: "5rem" }}>

      {/* Breadcrumb */}
      <nav className="mb-3">
        <ol className="breadcrumb bg-white px-3 py-2 shadow-sm rounded-3">
          <li className="breadcrumb-item">
            <Link to="/" className="text-decoration-none">
              <i className="fa-solid fa-house me-1"></i>  {t("menu.home")}
            </Link>
          </li>
          <li className="breadcrumb-item active">{t("typeActivite.titre")}</li>
        </ol>
      </nav>

      {/* Header */}
      <div className="card shadow-sm border-0 mb-3">
        <div className="card-body d-flex justify-content-between align-items-center">
          <h4 className="mb-0 fw-bold text-primary">
            <i className="fa-solid fa-list me-2"></i>
            {t("typeActivite.list")}
          </h4>

          <Link
            to="/Addactivitytype"
            className="btn btn-primary rounded-circle d-flex align-items-center justify-content-center"
            style={{ width: "45px", height: "45px" }}
            title={t("button.add")}
          >
            <i className="fa-solid fa-plus"></i>
          </Link>
        </div>
      </div>

      {/* Filters */}
      <div className="card shadow-sm border-0 mb-3">
        <div className="card-body">

          <div className="row g-2 align-items-center">

            {/* Search */}
            <div className="col-md-6">
              <div className="input-group">
                <span className="input-group-text bg-white">
                  <i className="fa-solid fa-magnifying-glass"></i>
                </span>
                <input
                  type="search"
                  className="form-control"
                  placeholder={t("button.search")}
                  onChange={(e) => {
                    firstPage();
                    setSearch(e.target.value);
                  }}
                />
              </div>
            </div>

            {/* Page size */}
            <div className="col-md-3">
              <select
                className="form-select"
                value={nombrEnreg}
                onChange={(e) => setNombreEnrg(e.target.value)}
              >
                <option value={5}>5 {t("common.rows")}</option>
                <option value={10}>10 {t("common.rows")}</option>
                <option value={20}>20 {t("common.rows")}</option>
              </select>
            </div>


            <div className="col-md-3">
              <select
                className="form-select"
                value={val}
                onChange={(e) => {
                  firstPage();
                  setVal(e.target.value);
                }}
              >
                <option value="">{t("consultant.filters.all")}</option>
                <option value="C">Crops</option>
                <option value="L">Livestock</option>
              </select>
            </div>

            {/* Sort */}
            <div className="col-md-3 text-end">
              <div className="btn-group">
                <button
                  className={`btn btn-outline-primary ${selectedValues.length === 0 ? "disabled" : ""}`}
                  onClick={SortTableAsc}
                >
                  <i className="fa-solid fa-arrow-down"></i>
                </button>
                <button
                  className={`btn btn-outline-primary ${selectedValues.length === 0 ? "disabled" : ""}`}
                  onClick={SortTableDesc}
                >
                  <i className="fa-solid fa-arrow-up"></i>
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Table */}
      <div className="card shadow-sm border-0">

        <div className="table-responsive">
          <table className="table table-striped table-hover">

            <thead className="table-dark">
              <tr>
                <th>
                  <input type="checkbox" value="cropsOrLivestock" onChange={handleCheckBoxChange} /> {t("monProfile.activityType")}
                </th>

                <th>
                  <input type="checkbox" value="activityType" onChange={handleCheckBoxChange} /> {t("common.french")}
                </th>
                <th>
                  <input type="checkbox" value="activityTypeArab" onChange={handleCheckBoxChange} /> {t("common.arabic")}
                </th>
                <th>
                  <input type="checkbox" value="activityTypeAng" onChange={handleCheckBoxChange} /> {t("common.english")}
                </th>
                <th className="text-center">{t("common.actions")}</th>
              </tr>
            </thead>

            <tbody>
              {activitytypeData.map((item) => (
                <tr key={item.id}>
                  <td> {getActivityTypeLabel(item.cropsOrLivestock)}</td>
                  <td>{item.activityType}</td>
                  <td>{item.activityTypeArab}</td>
                  <td>{item.activityTypeAng}</td>

                  <td className="text-center">
                    <Link
                      to={`/Updateactivitytype/${item.id}`}
                      className="btn btn-sm btn-outline-success me-2 rounded-circle"
                    >
                      <i className="fa-solid fa-pen"></i>
                    </Link>

                    <button
                      className="btn btn-sm btn-outline-danger rounded-circle"
                      onClick={() => selectId(item.id)}
                    >
                      <i className="fa-solid fa-trash"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>

          </table>
        </div>

        {/* Pagination */}
        <div className="card-footer bg-white border-0">
          <nav>
            <ul className="pagination justify-content-center mb-0">

              <li className={`page-item ${currentPage === 0 ? "disabled" : ""}`}>
                <button className="page-link" onClick={firstPage}>
                  «
                </button>
              </li>

              <li className={`page-item ${currentPage === 0 ? "disabled" : ""}`}>
                <button className="page-link" onClick={prePage}>
                  ‹
                </button>
              </li>

              {Array.from({ length: totalPages }).map((_, index) => (
                <li
                  key={index}
                  className={`page-item ${currentPage === index ? "active" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => setCurrentPage(index)}
                  >
                    {index + 1}
                  </button>
                </li>
              ))}

              <li className={`page-item ${currentPage === totalPages - 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={nextPage}>
                  ›
                </button>
              </li>

              <li className={`page-item ${currentPage === totalPages - 1 ? "disabled" : ""}`}>
                <button className="page-link" onClick={lastPage}>
                  »
                </button>
              </li>

            </ul>
          </nav>
        </div>

      </div>

      {/* Modal */}
      <ConfirmationModal
        isOpen={showConfirmationModal}
        onConfirm={deleteactivitytype}
        onCancel={handleCloseModal}
      />

    </div>
  );
}
